<template>
  <div class="grid --with-gutter">
    <div class="grid-cell size-3of5--md +mg-bottom-md">
      <div class="chart" style="width: 100%; height: 280px;"></div>
    </div>

    <div class="grid-cell size-2of5--md +mg-bottom-md">
      <slot name="subHeader"></slot>

      <dl class="list-bare +mg-bottom-md">
        <div
          v-for="(feed, index) in feeds"
          class="grid --align-center +brdr-bottom-gray +pd-bottom-sm +mg-bottom-sm"
          :key="index"
          v-bind:style="{ opacity: feed.visible ? 1 : 0.5 }"
        >
          <dt class="grid-cell size-fill +disply-flex +align-items-center">
            <span
              class="trends-list-bullet"
              v-bind:style="{ background: feed.color }"
            ></span>
            <span class="+type-body-one +text-crop-none +fg-slate">
              {{ feed.title.replace('Mortgage', '') }}
            </span>
          </dt>
          <dd class="grid-cell size-2of5">
            <slot :name="'feedRate' + index"></slot>
          </dd>
        </div>
      </dl>
      <slot name="rateLink"></slot>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import range from 'lodash/range'

export default {
  props: ['feeds'],
  data() {
    return {
      chart: null
    }
  },
  methods: {
    /**
     * Reformat data for highchart.
     * @param data
     */
    formatter(data) {
      return data
        .map(item => {
          return [
            item.Date.split('-').map(dateUnite => Number(dateUnite)),
            parseFloat(item.Rate.toFixed(2))
          ]
        })
        .map(item => {
          return [Date.UTC(item[0][0], item[0][1] - 1, item[0][2]), item[1]]
        })
    },

    /**
     * Initialize charts
     */
    initChart() {
      const vm = this
      let series = this.feeds.map(x => {
        x.data = vm.formatter(x.data)
        return {
          name: x.title,
          showInLegend: false,
          color: x.color,
          data: x.data,
          visible: x.visible
        }
      })

      this.chart = Highcharts.chart(this.$el.querySelector('.chart'), {
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          labels: {
            align: 'left',
            formatter: function() {
              return Highcharts.dateFormat('%b', this.value).toUpperCase()
            },
            style: {
              color: '#50525a',
              fontSize: '9px'
            },
            y: 15
          },
          tickLength: 0
        },
        yAxis: {
          labels: {
            enabled: false
          },
          title: {
            text: ''
          },
          tickPositioner: function(min, max) {
            const step = (max - min) / 4
            return range(min, max + step, step)
              .map(x => parseFloat(x.toFixed(2)))
              .slice(0, 5)
          }
        },
        title: {
          text: ''
        },
        series: series,
        plotOptions: {
          series: {
            lineWidth: 2
          },
          line: {
            marker: {
              enabled: false
            }
          }
        },
        tooltip: {
          formatter: function() {
            return (
              '<b>' +
              Highcharts.numberFormat(this.y, 2) +
              '%</b><br>' +
              this.series.name +
              '<br/>' +
              Highcharts.dateFormat('%m/%e/%Y ', this.x)
            )
          },
          headerFormat: '',
          useHTML: true
        },
        chart: {
          events: {
            render: vm.fixLabels
          }
        }
      })
    },

    /**
     * Fixes chart labels to have 2 decimals
     */
    fixLabels() {
      let labels = document.querySelectorAll('.chart tspan')
      for (let i = 0; i < labels.length; i += 1) {
        if (!labels[i].childNodes.length) {
          continue
        }
        let val = labels[i].childNodes[0].nodeValue
        if (val.indexOf('%') > 0) {
          labels[i].childNodes[0].nodeValue = parseFloat(val).toFixed(2) + '%'
        }
      }
    }
  },
  mounted() {
    this.initChart()
  },
  computed: {
    /**
     * Rate value from OA service.
     * @returns {string|response|{}|*|Object|boolean}
     */
    rate() {
      return (
        (typeof this.data[this.data.length - 1] !== 'undefined' &&
          Number(this.data[this.data.length - 1].ratevalue).toFixed(2)) ||
        0
      )
    }
  }
}
</script>

<style scoped>
.trends-list-bullet {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
}
</style>
